
import React, { useEffect, useState } from "react";
import classes from './StockDelivary.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from 'react-router-dom';
import { Pencil, Trash2, Printer } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import api, { withCompanyId } from '../../Components/API/Api';
import Select from "react-select";
import Swal from "sweetalert2";  // ✅ import Swal



const StockDelivary = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [suppliers, setSuppliers] = useState([]);
    const [storeOptions, setStoreOptions] = useState([]);
    const [orderOptions, setOrderOptions] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [pendingInvoices, setPendingInvoices] = useState([]);
    const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const uuids = selectedInvoiceDetails?.tax?.map(item => item.id) || [];
    const [deliveredOrders, setDeliveredOrders] = useState([]); // ✅ new state

    const [isActive, setIsActive] = useState(true);
    const [selectedMetrics, setSelectedMetrics] = useState(null);
    // Get token from localStorage

    const token = localStorage.getItem("authToken");
    useEffect(() => {
        if (!token) {
            console.error("No token found, redirecting to login...");
            navigate("/login");
            return;
        }
        fetchInvoices();
        fetchSuppliers();
        fetchStore();
        handleFetch();
    }, []);


    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const fetchInvoices = async () => {
        try {
            const response = await api.get("/v1/fetch-sales-invoice");

            setInvoiceItems(response.data.data || []);
        } catch (error) {
            if (error.response?.status === 401) {
                console.error("Unauthorized: Token expired or invalid.");
                localStorage.removeItem("authToken");
                navigate("/signin");
            } else {
                console.error("Failed to fetch invoices:", error);
            }
        } finally {
            setLoading(false);
        }
    };

    // ✅ Fetch Suppliers
    const fetchSuppliers = async () => {
        try {
            const response = await api.get("/v1/beneficiary");

            if (response.data.status) {
                const options = response.data.data.map((supplier) => ({
                    value: supplier.id,
                    label: supplier.name,
                }));
                setSuppliers(options);
            }
        } catch (error) {
            if (error.response?.status === 401) {
                console.error("Unauthorized: Token expired or invalid.");
                localStorage.removeItem("authToken");
                navigate("/login");
            } else {
                console.error("Failed to fetch suppliers:", error);
            }
        }
    };
    const fetchSupplierPendingInvoices = async (supplierId) => {
        try {
            const response = await api.get("/v1/fetch-supplier-pending-invoice", {
                params: { supplier_id: supplierId },
            });

            if (response.data?.status && Array.isArray(response.data.data)) {
                // Map options for Select
                const options = response.data.data.map(order => ({
                    value: order.id,            // invoice_number
                    label: order.invoice_number, // show only invoice_number
                    invoiceid: order.items?.id // show only invoice_number
                }));

                // Set state
                setOrderOptions(options);
                setPendingInvoices(response.data.data); // store full invoice details
            } else {
                setOrderOptions([]);
                setPendingInvoices([]);
            }
        } catch (error) {
            console.error("Failed to fetch supplier pending invoices:", error);
            setOrderOptions([]);
            setPendingInvoices([]);
        }
    };

        useEffect(() => {


        const fetchMetrics = async () => {
            try {
                const res = await api.get("/v1/metrics/stock-delivery-metrics");
                if (res.data && res.data.status && res.data.data) {
                    // Remove Array.isArray check since data is an object
                    setSelectedMetrics(res.data.data);
                }
            } catch (err) {
               setSelectedMetrics(null);
            }
        };
        fetchMetrics();
    }, []);



    const fetchStore = async () => {
        try {
            const response = await api.get("/v1/store");

            if (response.data.status) {
                const options = response.data.data.map((s) => ({
                    value: s.id,
                    label: s.store_name,
                }));
                setStoreOptions(options);
            }
        } catch (error) {
            if (error.response?.status === 401) {
                console.error("Unauthorized: Token expired or invalid.");
                localStorage.removeItem("authToken");
                navigate("/login");
            } else {
                console.error("Failed to fetch stores:", error);
            }
        }
    };

    // Dummy Options for Order/Store

    const [formData, setFormData] = useState({
        supplier_id: "",
        invoice_number: "",
        store_id: "",
        invoice_id: "",
        quantity: 0,
        supplied_price: 0,
        supplied_amount: 0,
    });

    // Handle dropdown changes
    const handleChange = (field, value) => {
        setFormData((prev) => {
            let updates = { [field]: value };

            // ✅ Map VAT/WHT to tax_id & tax_value
            if (field === "tax") {
                if (value === "VAT") {
                    updates.tax_id = 1;
                    updates.tax_value = 0.75;
                } else if (value === "WHT") {
                    updates.tax_id = 2;
                    updates.tax_value = 0.02;
                } else {
                    updates.tax_id = null;
                    updates.tax_value = 0;
                }
            }

            return {
                ...prev,
                ...updates,
            };
        });
    };

    // Handle numeric input changes
    const handleNumberChange = (field, value) => {
        const num = parseFloat(value) || 0;
        setFormData((prev) => {
            const updated = { ...prev, [field]: num };

            // auto calculate supplied_amount
            if (field === "quantity" || field === "supplied_price") {
                updated.supplied_amount =
                    (updated.quantity || 0) * (updated.supplied_price || 0);
            }

            return updated;
        });
    };

    // Submit to API

    const handleSubmit = async () => {
        // Debug: log all form values
        console.log("Form Data:", {
            supplier_id: formData.supplier_id,
            invoice_number: formData.invoice_number,
            invoice_id: formData.invoice_id,
            store_id: formData.store_id,
        });

        if (
            !formData.supplier_id ||
            !formData.invoice_number ||
            !formData.invoice_id ||
            !formData.store_id
        ) {
            const missing = [];
            if (!formData.supplier_id) missing.push("Supplier");
            if (!formData.invoice_number) missing.push("Order");
            if (!formData.invoice_id) missing.push("Invoice");
            if (!formData.store_id) missing.push("Store");

            Swal.fire({
                icon: "warning",
                title: "Missing Information",
                text: `The following are required: ${missing.join(", ")}`,
            });
            return;
        }

        if (!selectedInvoiceDetails?.items || selectedInvoiceDetails.items.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "Invalid Invoice",
                text: "Please select a valid invoice with items.",
            });
            return;
        }

        const itemIds = selectedInvoiceDetails.items.map(item => item.item_id);
        const quantitySupplied = selectedInvoiceDetails.items.map(item => Number(item.supplied_quantity) || 0);
        const suppliedPrice = selectedInvoiceDetails.items.map(item => Number(item.supplied_price) || 0);
        const invoiceId = selectedInvoiceDetails.items.map(item => Number(item.id) || 0);

        // Round all per-item calculations to 2 decimal points
        const suppliedAmount = selectedInvoiceDetails.items.map(item => parseFloat((item.supplied_amount || 0).toFixed(2)));
        const discount = selectedInvoiceDetails.items.map(item => parseFloat((item.discount || 0).toFixed(2)));
        const discount_percentage = selectedInvoiceDetails.items.map(item => parseFloat((item.discountRate || 0).toFixed(2)));
        const tax_id = selectedInvoiceDetails.items.map(item => item.vatChecked ? 1 : null);
        const wht_id = selectedInvoiceDetails.items.map(item => item.whtChecked ? 2 : null);

        // ✅ Calculate per-line VAT and WHT properly
        const vatAmounts = selectedInvoiceDetails.items.map((item, idx) => {
            const qty = Number(item.supplied_quantity) || 0;
            const price = Number(item.supplied_price) || 0;
            const discount = Number(item.discount) || 0;
            const net = qty * price - discount;
            return tax_id[idx] ? net * 0.075 : 0;  // 7.5% VAT
        });

        const whtAmounts = selectedInvoiceDetails.items.map((item, idx) => {
            const qty = Number(item.supplied_quantity) || 0;
            const price = Number(item.supplied_price) || 0;
            const discount = Number(item.discount) || 0;
            const net = qty * price - discount;
            return wht_id[idx] ? net * 0.02 : 0;   // 2% WHT
        });

        // ✅ Totals
        const total_discount = discount.reduce((a, b) => a + b, 0);
        const total_vat = vatAmounts.reduce((a, b) => a + b, 0);
        const total_wht = whtAmounts.reduce((a, b) => a + b, 0);
        const total_price = suppliedAmount.reduce((a, b) => a + b, 0);

        // Payload with purchase_order_id added (this is the key fix)
        const payload = {
            supplier_id: formData.supplier_id,
            invoice_number: formData.invoice_number,
            purchase_order_id: formData.invoice_number, // ✅ Add this required field
            invoice_id: invoiceId,
            store_id: formData.store_id,
            quantity_supplied: quantitySupplied,
            supplied_price: suppliedPrice,
            supplied_amount: suppliedAmount,
            item: itemIds,
            discount,
            discount_percentage,
            tax_id,
            wht_id,
            delivery_date: new Date().toISOString().split('T')[0], // ✅ Try adding delivery date
            total_vat: parseFloat(total_vat.toFixed(2)),
            total_wht: parseFloat(total_wht.toFixed(2)),
            total_price: parseFloat(total_price.toFixed(2)),
            total_discount: parseFloat(total_discount.toFixed(2))
        };

        console.log("Submitting payload:", payload);

        setIsSubmitting(true);
        try {
            const response = await api.post(
                "/v1/stock-delivery",
                withCompanyId(payload)
            );

            Swal.fire({
                icon: "success",
                title: "Success!",
                text: response.data?.message || "Stock delivery processed successfully 🎉",
                timer: 3000,
                showConfirmButton: false,
            });

            setIsModalOpen(false);
            fetchInvoices();
            handleFetch();

        } catch (error) {
            console.error("Error:", error.response?.data || error.message);

            Swal.fire({
                icon: "error",
                title: "Error!",
                text: error.response?.data?.message || error.response?.data?.data || "Failed to process delivery. Please try again.",
            });
        } finally {
            setIsSubmitting(false);
        }
    };


    // 👇 compute total based on current selectedInvoiceDetails
    const totalSuppliedAmount = selectedInvoiceDetails?.items
        ? selectedInvoiceDetails.items.reduce(
            (acc, item) => acc + Number(item.supplied_amount || 0),
            0
        )
        : 0;

    const handleFetch = async () => {
        setLoading(true);
        try {
            const res = await api.get("/v1/delivered-purchase-order");

            // ✅ Write into deliveredOrders, not invoiceItems
            setDeliveredOrders(res.data?.data?.orders || []);
        } catch (error) {
            console.error(
                "Error fetching delivered purchase orders:",
                error.response?.data || error.message
            );
        } finally {
            setLoading(false);
        }
    };
    const handleItemChange = (index, field, value) => {
        setSelectedInvoiceDetails((prev) => {
            if (!prev) return prev;

            const updatedItems = [...prev.items];
            let newValue = value;

            // Convert number fields
            if (["supplied_quantity", "supplied_price", "discountRate", "discount"].includes(field)) {
                newValue = Number(value) || 0;
            }

            // Update field
            updatedItems[index] = {
                ...updatedItems[index],
                [field]: newValue,
            };

            // ✅ Base amount
            const qty = Number(updatedItems[index].supplied_quantity) || 0;
            const price = Number(updatedItems[index].supplied_price) || 0;
            const baseAmount = qty * price;

            let discount = updatedItems[index].discount ?? null;
            let discountRate = updatedItems[index].discountRate ?? null;

            // ✅ If user typed % discount → calculate amount
            if (field === "discountRate") {
                discount = (newValue / 100) * baseAmount;
                updatedItems[index].discount = discount;
            }

            // ✅ If user typed discount amount → calculate %
            if (field === "discount") {
                discountRate = baseAmount > 0 ? (newValue / baseAmount) * 100 : 0;
                updatedItems[index].discountRate = discountRate;
            }

            // ✅ Net after discount (only if discount entered)
            const netAmount = baseAmount - (updatedItems[index].discount || 0);

            /// ✅ Apply VAT (7.5%) with tax_id = 1
            let vat = 0;
            if (updatedItems[index].vatChecked) {
                vat = netAmount * 0.075;   // (⚠️ you had 0.75 earlier, should be 0.075 = 7.5%)
                updatedItems[index].tax_id_vat = 1;
                updatedItems[index].vat = vat;
            } else {
                updatedItems[index].tax_id_vat = null;
                updatedItems[index].vat = 0;
            }

            // ✅ Apply WHT (2%) with tax_id = 2
            let wht = 0;
            if (updatedItems[index].whtChecked) {
                wht = netAmount * 0.02;
                updatedItems[index].tax_id_wht = 2;
                updatedItems[index].wht = wht;
            } else {
                updatedItems[index].tax_id_wht = null;
                updatedItems[index].wht = 0;
            }



            // ✅ Final supplied amount
            // ✅ Final supplied amount (include VAT + WHT)
            updatedItems[index].supplied_amount = netAmount + vat + wht;

            // ✅ Recalculate totals
            const subtotal = updatedItems.reduce(
                (sum, item) => sum + (item.supplied_amount || 0),
                0
            );


            return {
                ...prev,
                items: updatedItems,
                totals: { subtotal },
            };
        });
    };






    // Format numbers with commas and 2 decimal places
    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === "") return "0.00";
        return new Intl.NumberFormat("en-NG", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(value));
    };



    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>

                <div className={classes.Container}>
                    <div className={classes.actions}>
                        <button
                            className={classes.btns}
                            onClick={() => navigate('/transactions/sales-invoice/sale')}
                        >
                            Sales Invoice
                        </button>
                        <button
                            className={classes.btns}
                            onClick={() => navigate('/Inventory/PurchaseOrder')}
                        >
                            Purchase Order
                        </button>
                        <button
                            className={`${classes.btns} ${isActive ? classes.active : ""}`}
                            onClick={() => setIsActive(true)}
                        >
                            Stock Delivery
                        </button>
                        <button onClick={() => navigate('/settings/product-services')} className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                    </div>

                    <header className={classes.Header}>
                        <h2 className={classes.Title}>Stock Delivery</h2>

                    </header>

                    <div className={classes.entrjj}>
                        <div className={classes.allkads}>
                            <div className={classes.thrdkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Total sales</p>
                                    <p className={classes.kdptg1}>{selectedMetrics?.total_purchase?.toLocaleString() ?? '0'}</p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>This month</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.frtkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Outstanding</p>
                                    <p className={classes.kdptg2}>{selectedMetrics?.outstanding?.toLocaleString() ?? '0'}</p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Pending payments</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.fiftkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Overdue</p>
                                    <p className={classes.kdptg3}>{}</p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Past due dates</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.frstkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>This month</p>
                                    <p className={classes.kdptg4}>15</p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Total invoices</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={classes.headerActions}>
                        <div className={classes.actionsRight}>
                            <div className={classes.inputWrapper}>
                                <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                                <input type="text" className={classes.searchBar} placeholder="Search sales" />
                            </div>
                            <div className={classes.selectWrapper}>
                                <select className={classes.dropdown}>
                                    <option value="">All Status</option>
                                    <option value="Paid">Paid</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Overdue">Overdue</option>
                                    <option value="Draft">Draft</option>
                                </select>
                                <span className={classes.dropdownArrow}>▼</span>
                            </div>
                            <div className={classes.inputWrapper}>
                                <input type="text" className={classes.searchBars} placeholder="Filter..." />
                                <img src={filter} alt="Filter" className={classes.inputIcon} />
                            </div>
                        </div>
                        <button
                            className={classes.btnss}
                            onClick={() => setIsModalOpen(true)}
                        >
                            + New Delivery
                        </button>

                        {isModalOpen && (
                            <div className={classes.modalOverlay}
                                onClick={() => setIsModalOpen(false)} // clicking the overlay closes the modal
                            >
                                <div className={classes.modalContent}
                                    onClick={(e) => e.stopPropagation()} // prevent modal click from closing
                                >
                                    {/* Modal Header */}
                                    <div className={classes.modalHeader}>
                                        <h2>New Stock Delivery</h2>
                                        <button
                                            className={classes.closeBtn}
                                            onClick={() => setIsModalOpen(false)}
                                        >
                                            ×
                                        </button>
                                    </div>

                                    {/* Modal Body */}
                                    <div className={classes.modalBody}>
                                        <div className={classes.formRow}>
                                            <div className={classes.formGroup}>
                                                <label>Supplier</label>
                                                <Select
                                                    options={suppliers}
                                                    placeholder="Select supplier"
                                                    value={suppliers.find(opt => opt.value === formData.supplier_id) || null}
                                                    isLoading={suppliers.length === 0}
                                                    onChange={(option) => {
                                                        handleChange("supplier_id", option.value);
                                                        setOrderOptions([]); // clear old orders
                                                        fetchSupplierPendingInvoices(option.value); // fetch pending orders dynamically
                                                    }}
                                                />



                                            </div>
                                            <div className={classes.formGroup}>
                                                <label>Order ID</label>
                                                <Select
                                                    options={orderOptions}
                                                    placeholder="Select Invoice"
                                                    value={orderOptions.find(opt => opt.value === formData.invoice_number) || null}
                                                    onChange={(option) => {
                                                        handleChange("invoice_number", option.value);

                                                        const invoice = pendingInvoices.find(inv => inv.id === option.value);
                                                        if (invoice) {
                                                            console.log("Selected Invoice:", invoice); // Debug log
                                                            setSelectedInvoiceDetails({
                                                                ...invoice,
                                                                items: invoice.items.map((it) => ({
                                                                    ...it,
                                                                    discount: "",
                                                                    discountRate: "",
                                                                })),
                                                            });
                                                            handleChange("invoice_id", invoice.id);

                                                            // ✅ Match store by store_name from storeOptions
                                                            const storeName = invoice.store?.store_name || invoice.store_name || "";
                                                            const matchedStore = storeOptions.find(store => store.label === storeName);
                                                            const storeId = matchedStore?.value || "";
                                                            console.log("Store Name:", storeName, "Matched Store ID:", storeId); // Debug log
                                                            handleChange("store_id", storeId);
                                                        }
                                                    }}

                                                />
                                            </div>



                                        </div>

                                        <div className={classes.formRow}>
                                            <div className={classes.formGroup}>
                                                <label>Store</label>
                                                <Select
                                                    options={storeOptions}
                                                    placeholder="Select Store"
                                                    value={storeOptions.find(opt => opt.value === formData.store_id) || null}
                                                    isDisabled={storeOptions.length === 0}
                                                    onChange={(option) => {
                                                        handleChange("store_id", option.value);
                                                    }}
                                                />
                                            </div>


                                            <div className={classes.formGroup}>
                                                <label>Supporting Doc.</label>
                                                <label className={classes.fileInput}>
                                                    {selectedFile ? selectedFile.name : "Choose File"}
                                                    <input
                                                        type="file"
                                                        hidden
                                                        onChange={(e) => setSelectedFile(e.target.files[0])}
                                                    />
                                                </label>

                                            </div>
                                        </div>

                                        {/* Table Section */}
                                        <div className={classes.tableWrapper}>
                                            <table className={classes.table}>
                                                <thead>
                                                    <tr>
                                                        <th>Items Description</th>
                                                        <th>Price</th>
                                                        <th>Quantity</th>
                                                        <th>Amount</th>

                                                        <th>Supplied Quantity</th>
                                                        <th>Supplied Price</th>
                                                        <th>Discount (%)</th>
                                                        <th>Discount</th>
                                                        <th>
                                                            VAT
                                                        </th>
                                                        <th>
                                                            WHT
                                                        </th>
                                                        <th>Supplied Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedInvoiceDetails ? (
                                                        selectedInvoiceDetails.items.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        value={item.item?.name || ""}
                                                                        readOnly
                                                                        className={classes.inputneww1}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        value={parseFloat(item.price) || 0}
                                                                        readOnly
                                                                        className={classes.inputneww2}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        value={parseFloat(item.quantity) || 0}
                                                                        readOnly
                                                                        className={classes.inputneww}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <p className={classes.inputneww3}>
                                                                        {parseFloat(item.amount) || 0}
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        value={item.supplied_quantity || ""}
                                                                        className={classes.inputneww}
                                                                        onChange={(e) =>
                                                                            handleItemChange(index, "supplied_quantity", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        value={item.supplied_price || ""}
                                                                        className={classes.inputneww}
                                                                        onChange={(e) =>
                                                                            handleItemChange(index, "supplied_price", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        value={item.discountRate || ""}
                                                                        onChange={(e) => handleItemChange(index, "discountRate", e.target.value)}
                                                                        className={classes.inputneww}
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        value={item.discount || ""}
                                                                        onChange={(e) => handleItemChange(index, "discount", e.target.value)}
                                                                        className={classes.inputneww}
                                                                    />
                                                                </td>


                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={item.vatChecked || false}
                                                                        onChange={(e) =>
                                                                            handleItemChange(index, "vatChecked", e.target.checked)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={item.whtChecked || false}
                                                                        onChange={(e) =>
                                                                            handleItemChange(index, "whtChecked", e.target.checked)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        value={formatCurrency(item.supplied_amount || 0)}
                                                                        className={classes.inputneww}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={9}>Select an invoice to see details</td>
                                                        </tr>
                                                    )}
                                                </tbody>





                                            </table>
                                        </div>


                                        {/* Total */}
                                        <div className={classes.totalRow}>
                                            <span>Total Supplied Amount:</span>
                                            <input
                                                type="text"
                                                value={formatCurrency(totalSuppliedAmount)}
                                                readOnly
                                            />
                                        </div>



                                    </div>

                                    {/* Modal Footer */}
                                    <div className={classes.modalFooter}>

                                        <button
                                            className={classes.processBtn}
                                            onClick={handleSubmit}
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Processing..." : "Process Delivery"}
                                        </button>

                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                    {/* <div className={classes.action}>
                        <button className={classes.btn} onClick={() => navigate('/transactions/newaction')}>
                            + Action
                        </button>
                    </div> */}
                    <table className={classes.invoiceTable}>
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Order ID</th>
                                <th>Supplier</th>
                                <th>Supplied Quantity</th>
                                <th>Supplied Price</th>
                                <th>Supplied Amount</th>
                                <th>Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center" }}>Loading...</td>
                                </tr>
                            ) : deliveredOrders.length > 0 ? (
                                deliveredOrders.map((row, index) => (
                                    <tr key={row.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{row.invoice_number}</td>
                                        <td>{row.supplier?.name}</td>
                                        <td>{row.quantity_supplied}</td>
                                        <td style={{textAlign:'right'}}>{row.supplied_price}</td>
                                        <td style={{textAlign:'right'}}>{row.supplied_amount}</td>
                                        <td>{new Date(row.created_at).toLocaleDateString()}</td>
                                        <td>...</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center" }}>No records found</td>
                                </tr>
                            )}
                        </tbody>

                    </table>

                </div>


            </div>
            <Footer />
        </div >
    );
};

export default StockDelivary;
